import styled from "styled-components";
import FadeIn from "react-fade-in/lib/FadeIn";

export const FlexGrid = styled(FadeIn)`
  display: flex;
  flex-wrap: wrap;
  background-color: #f1f5f9;
  padding: 50px 0px;
  padding-bottom : 20px;
  text-align: center;
  justify-content: center;
`;